import { mapGetters } from "vuex";

export const chatUsernameMixin = {
  computed: {
    ...mapGetters({
      selectedProviderID: "getSelectedProviderID"
    }),
    ...mapGetters({
      userDetails: "getUserDetails"
    }),
    ...mapGetters({
      appointmentType: "getAppointmentType"
    }),
    ...mapGetters("chat", {
      selectedUserId: "getSelectedUserId",
      name: "getName",
      friends: "getFriends"
    }),
    userId() {
      return this.userDetails.id;
    },
    clients() {
      return this.appointmentType.clients;
    },
    people() {
      return this.appointmentType.people;
    },
    appUsers() {
      return this.appointmentType.appUsers;
    },
    subscribers() {
      return this.appointmentType.subscribers;
    },
    username() {
      if (this.friends && this.selectedUserId in this.friends) {
        if ("fullName" in this.friends[this.selectedUserId]) {
          return this.friends[this.selectedUserId].fullName;
        } else {
          return this.formatName(
            this.friends[this.selectedUserId].firstName,
            this.friends[this.selectedUserId].middleName,
            this.friends[this.selectedUserId].lastName,
            this.friends[this.selectedUserId].namePrefix,
            this.friends[this.selectedUserId].nameSuffix,
            null,
            "chat"
          );
        }
      } else if (this.selectedProviderID in this.clients) {
        const client = this.clients[this.selectedProviderID].find(curClient => {
          return curClient.user_id === this.selectedUserId;
        });

        if (client) {
          return client.name;
        }
      }

      // For person
      if (this.selectedProviderID in this.people) {
        const person = this.people[this.selectedProviderID].find(curPerson => {
          return curPerson.user_id === this.selectedUserId;
        });

        if (person) {
          return person.name;
        }
      }

      // For app users
      if (this.selectedProviderID in this.appUsers) {
        const appUser = this.appUsers[this.selectedProviderID].find(
          curAppUser => {
            return curAppUser.user_id === this.selectedUserId;
          }
        );

        if (appUser) {
          return appUser.name;
        }
      }

      // For subscribers
      const subscriber = this.subscribers.find(curSubscriber => {
        return curSubscriber.user_id === this.selectedUserId;
      });

      if (subscriber) {
        return subscriber.name;
      }

      return this.name.lastName + ", " + this.name.firstName;
    }
  }
};
